import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const ResultsChartsDataContext = createContext();

const ResultsChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.RESULTS_LIVE_BIRTHS,
            url: 'governanceroom/dashboard/vitalstatistics/live-births/results'
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  averageRegisterTime:
                      data?.indicators?.averageRegisterTime ?? 0
              },
              annualLiveBirths: data?.annualLiveBirths ?? [],
              birthTime: data?.birthTime ?? [],
              monthlyLiveBirths: data?.monthlyLiveBirths ?? []
          }
        : {
              indicators: {
                  averageRegisterTime: 0
              },
              annualLiveBirths: [],
              birthTime: [],
              monthlyLiveBirths: []
          };

    return (
        <ResultsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ResultsChartsDataContext.Provider>
    );
};

export default ResultsChartsDataProvider;
